/**
 * Happy dog - virtual pet for you and friends
 *
 * Its single web-accessible-resource entry exposes `Open_Sans/*` and `images/*` to every
 * http(s) origin with no `use_dynamic_url` — so every bundled image is fetchable from any
 * page at a fixed URL. Only images are exposed, so both signals load through `probeImage`
 * with no CORS grant: `app-banner.png` and `ball.png` are vendor-specific sprite art.
 *
 * Manifest verified against version 2.41.0.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cdoblkdcnbcdlcfklmbmkapbekgfbijp';

export const happyDog: ExtensionDefinition = {
  id: ID,
  name: 'Happy dog - virtual pet for you and friends',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 70_000,
  notes:
    'Exposes images/* to every http(s) origin with no dynamic URL. The vendor sprite art ' +
    'loads via <img> without a CORS grant, so detection is conclusive and CORS-free.',
  signals: [
    {
      id: 'war-app-banner-image',
      kind: 'web-accessible-resource',
      description:
        'Load images/app-banner.png via <img> — a vendor image exposed to every origin; ' +
        'needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/app-banner.png'),
    },
    {
      id: 'war-ball-image',
      kind: 'web-accessible-resource',
      description:
        'Load images/ball.png via <img> — a second sprite image that corroborates and ' +
        'survives either one being renamed.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/ball.png'),
    },
  ],
};
